export default "__VITE_ASSET__a91b8d25__"